import React, { FC } from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';


const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref,
) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


/**
 * ISnackbarToast Interface
 *
 * @interface ISnackbarToast
 * @typedef {ISnackbarToast}
 */
interface ISnackbarToast {
    showSnackBar: ISnackbarObject;
    handleClose: any
}


/**
 * ISnackbarObject Interface
 * @date 15/02/2023 - 19:05:21
 *
 * @interface ISnackbarObject
 * @typedef {ISnackbarObject}
 */
interface ISnackbarObject {
    show: boolean,
    message: string,
    severity: any
}

/**
 * Snackbar Toaster on response
 *
 * @param {{ showSnackBar: any; handleClose: any; }} {
    showSnackBar, handleClose
}
 * @returns {*}
 */
const SnackbarToast: FC<ISnackbarToast> = ({
    showSnackBar, handleClose
}) => {

    return (
        <Snackbar open={showSnackBar.show} anchorOrigin={{ vertical: 'top', horizontal: 'right', }} onClose={handleClose}>
            <Alert severity={showSnackBar.severity} sx={{ width: '100%' }} onClose={handleClose}>
                {showSnackBar.message}
            </Alert>
        </Snackbar>
    );
}

export default SnackbarToast;